import Image from 'next/image';
import styled from 'styled-components';
import {useTranslation} from 'next-i18next';
import {brandRadius, panelistaDarkColor, purpleBankColor} from 'src/utils/constants';
import {PhoneShape} from '../landingStyledComponents';

const ContentContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 50px 16px 20px 16px;

  span {
    width: 100%;
  }
`;

const LogoContainer = styled.div`
  font-size: 16px;
  font-weight: 600;
  background-color: ${purpleBankColor};
  color: white;
  padding: 6px 10px;
`;

const ImageContainer = styled.div`
  position: relative;
  width: 150px;
  height: 180px;
  background-color: ${panelistaDarkColor};
  border-radius: 20px;
  overflow: hidden;
`;

const ButtonShape = styled.div`
  width: 100%;
  height: 42px;
  background-color: ${purpleBankColor};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.2;
  border-radius: ${brandRadius}px;
`;

const TouchpointEmailExampleGraphic = () => {
  const {t, i18n} = useTranslation();

  return (
    <a
      href={`https://panelista.com/touchpoints/${
        i18n.language === 'sv' ? '6183dd05edb4650016f91b43' : '6183dd4aedb4650016f91b82'
      }`}
      target="_blank"
      onClick={() => plausible('Touchpoint example clicked', {props: {place: 'Touchpoints', actor: 'Charlotta'}})}
    >
      <PhoneShape hoverable>
        <ContentContainer>
          <LogoContainer>PURPLE BANK</LogoContainer>

          <ImageContainer>
            <Image src="/images/touchpointExampleThreeImage.jpg" fill alt="Video question in email" sizes="300px" />
          </ImageContainer>

          <span style={{fontWeight: 600, color: 'var(--black-text)'}}>
            {t('website.touchpoint example three question')}
          </span>

          <span style={{fontSize: 13, color: 'var(--gray-text)'}}>
            {t('website.touchpoint example three greeting')},<br />
            Charlotta Alexén, CXO
          </span>

          <ButtonShape>{t('common.play video and answer')}</ButtonShape>
        </ContentContainer>
      </PhoneShape>
    </a>
  );
};

export default TouchpointEmailExampleGraphic;
